




















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { CauseMeasure } from "@/views/biaggregate/types";

@Component({
  components: {
    AppAuthButton,
  },
})
export default class CauseMeasureList extends Mixins(AxiosMixin) {
  /** 主因仮説/打ち手コメントマスタ */
  @Prop({ default: () => [] }) causeMeasures!: CauseMeasure[];

  /** 絞り込み用文字列 */
  private searchText = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** ヘッダー */
  private headers = [
    {
      text: "",
      value: "action",
      sortable: false,
      align: "start",
      width: "80px",
    },
    {
      text: "ID",
      value: "id",
      sortable: true,
      filterable: true,
      align: "start",
      width: "80px",
    },
    {
      text: "指標種類",
      value: "metrics_type_name",
      sortable: true,
      filterable: true,
      align: "start",
      width: "160px",
    },
    {
      text: "指標レベル",
      value: "metrics_level_name",
      sortable: true,
      filterable: true,
      align: "start",
      width: "120px",
    },
    {
      text: "主因仮説",
      value: "cause",
      sortable: false,
      filterable: false,
      align: "start",
      width: "200px",
    },
    {
      text: "打ち手タイトル",
      value: "measures_title",
      sortable: false,
      filterable: false,
      align: "start",
      width: "200px",
    },
    {
      text: "打ち手",
      value: "measures",
      sortable: false,
      filterable: false,
      align: "start",
      width: "200px",
    },
    {
      text: "最終更新日時",
      value: "updated_at_str",
      sortable: true,
      filterable: false,
      align: "start",
      width: "140px",
    },
    {
      text: "最終更新者",
      value: "editor_admin_name",
      sortable: true,
      filterable: false,
      align: "start",
      width: "150px",
    },
  ];

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  @Emit("click:edit")
  private edit(id: number) {
    return id;
  }
}
